// relative
import GlobalAlert from './GlobalAlert';
// components
import { useGlobalAlert } from './GlobalAlertContext';

export default function GlobalAlertContainer() {
  const { alert, clearAlert } = useGlobalAlert();

  return (
    <GlobalAlert
      open={!!alert}
      severity={alert?.severity ?? 'info'}
      title={alert?.title}
      message={alert?.message}
      action={alert?.action}
      onClose={() => clearAlert(alert?.ownerId)}
    />
  );
}
